"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FileHasher", {
    enumerable: true,
    get: function() {
        return FileHasher;
    }
});
const _gracefulfs = /*#__PURE__*/ _interop_require_default(require("graceful-fs"));
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _globhasher = require("glob-hasher");
const _nodereadline = require("node:readline");
const _getPackageDeps = require("./getPackageDeps.js");
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _store = /*#__PURE__*/ new WeakMap(), _manifestFile = /*#__PURE__*/ new WeakMap();
class FileHasher {
    async getHashesFromGit() {
        const { root } = this.options;
        const fileHashes = await (0, _getPackageDeps.getPackageDeps)(root);
        const files = [
            ...fileHashes.keys()
        ];
        const fileStats = (0, _globhasher.stat)(files, {
            cwd: root
        }) ?? {};
        for (const [relativePath, fileStat] of Object.entries(fileStats)){
            const hash = fileHashes.get(relativePath);
            if (hash) {
                const { size, mtime } = fileStat;
                _class_private_field_get(this, _store)[relativePath] = {
                    hash,
                    size,
                    mtime
                };
            }
        }
        this.writeManifest();
    }
    async readManifest() {
        return new Promise((resolve)=>{
            if (!_gracefulfs.default.existsSync(_class_private_field_get(this, _manifestFile))) {
                this.getHashesFromGit().then(()=>resolve());
                return;
            }
            const inputStream = _gracefulfs.default.createReadStream(_class_private_field_get(this, _manifestFile), "utf-8");
            const rl = (0, _nodereadline.createInterface)({
                input: inputStream,
                crlfDelay: Infinity
            });
            let info = [];
            rl.on("line", (line)=>{
                info = line.split("\0");
                _class_private_field_get(this, _store)[info[0]] = {
                    mtime: BigInt(info[1]),
                    size: parseInt(info[2]),
                    hash: info[3]
                };
            });
            inputStream.on("end", ()=>{
                rl.close();
                resolve();
            });
        });
    }
    writeManifest() {
        _gracefulfs.default.mkdirSync(_path.default.dirname(_class_private_field_get(this, _manifestFile)), {
            recursive: true
        });
        const outputLines = Object.entries(_class_private_field_get(this, _store)).map(([relativePath, info])=>{
            return `${relativePath}\0${info.mtime.toString()}\0${info.size.toString()}\0${info.hash}`;
        });
        _gracefulfs.default.writeFileSync(_class_private_field_get(this, _manifestFile), outputLines.join("\n"), "utf-8");
    }
    hash(files) {
        const hashes = {};
        const updatedFiles = [];
        const stats = (0, _globhasher.stat)(files, {
            cwd: this.options.root
        }) ?? {};
        for (const file of files){
            const stat = stats[file];
            const info = _class_private_field_get(this, _store)[file];
            if (info && stat.mtime === info.mtime && stat.size == info.size) {
                hashes[file] = info.hash;
            } else {
                updatedFiles.push(file);
            }
        }
        const updatedHashes = (0, _globhasher.hash)(updatedFiles, {
            cwd: this.options.root,
            concurrency: 4
        }) ?? {};
        for (const [file, hash] of Object.entries(updatedHashes)){
            const stat = _gracefulfs.default.statSync(_path.default.join(this.options.root, file), {
                bigint: true
            });
            _class_private_field_get(this, _store)[file] = {
                mtime: stat.mtimeMs,
                size: Number(stat.size),
                hash: hash ?? ""
            };
            hashes[file] = hash ?? "";
        }
        return hashes;
    }
    constructor(options){
        _define_property(this, "options", void 0);
        _class_private_field_init(this, _store, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _manifestFile, {
            writable: true,
            value: void 0
        });
        this.options = options;
        _class_private_field_set(this, _store, {});
        const { root } = options;
        const cacheDirectory = _path.default.join(root, "node_modules", ".cache", "lage");
        _class_private_field_set(this, _manifestFile, _path.default.join(cacheDirectory, "file_hashes.manifest"));
    }
}
